import { render, staticRenderFns } from "./NewHeraFormCheckBox.vue?vue&type=template&id=2a2f4f82&scoped=true&"
import script from "./NewHeraFormCheckBox.vue?vue&type=script&lang=js&"
export * from "./NewHeraFormCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./NewHeraFormCheckBox.vue?vue&type=style&index=0&id=2a2f4f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f4f82",
  null
  
)

export default component.exports